export const data = [
    {
        id: 1,
        title: 'Yemek.com Analytics Verileri',
        titleEN: 'Yemek.com Analytics Data',
        image: 'https://srv-cdn.onedio.com/store/58392c74a93b1f9dd024c335d950a20723d26d28bf711ebc841cec789bb2d119.png',
        imageEN: 'https://srv-cdn.onedio.com/store/8e85b0a38c152ae2b2daf8ac1a83dd5b8b26f151c492c957bdcef9f8c0610df9.png',
        active: true
    },
    {
        id: 2,
        title: 'Cinsiyet',
        titleEN: 'Gender',
        image: 'https://srv-cdn.onedio.com/store/5486c2f37ef63b4b55b9ba04ee685e7150c5e59e6064c08d2db93ec30500e56f.png',
        imageEN: 'https://srv-cdn.onedio.com/store/5486c2f37ef63b4b55b9ba04ee685e7150c5e59e6064c08d2db93ec30500e56f.png',
        active: false
    },
    {
        id: 3,
        title: 'Yaş Kırılımı',
        titleEN: 'Age Distribution',
        image: 'https://srv-cdn.onedio.com/store/1c8d6a649df7dc55495804ace0975456bfd11ad32c67bdfc73836b26fb7ad004.png',
        imageEN: 'https://srv-cdn.onedio.com/store/1c8d6a649df7dc55495804ace0975456bfd11ad32c67bdfc73836b26fb7ad004.png',
        active: false
    },
    {
        id: 4,
        title: 'Sosyal Medya',
        titleEN: 'Social Media',
        image: 'https://srv-cdn.onedio.com/store/cbb3ac9bdc6fe0c6f314d8efbb65468594f71c0c8946c157af5c0f435a094108.png',
        imageEN: 'https://srv-cdn.onedio.com/store/0f5aa9a08307649c81ddb1e77d6928718e89b67a681fdfffe33c2f096d8e678d.png',
        active: false
    }
] 